import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import {
  InputField,
  SelectFieldAdditionalItem,
  SelectFieldPassengerAndLuggage,
  SelectFieldWithMap,
} from 'components/Global';
import InputTelpField from 'components/Global/InputTelpField';
import SelectFieldDate from 'components/Global/SelectFieldDate';
import SelectFieldTime from 'components/Global/SelectFieldTime';
import { ReactComponent as FlightIcon } from 'icons/plane-icon.svg';
import { ReactComponent as DetailLocationIcon } from 'icons/detail-location-icon.svg';
import BlueMappin from 'icons/mappin-icon-blue.svg';
import YellowMappin from 'icons/mappin-icon-yellow.svg';
import { ReactComponent as SwitchIcon } from 'icons/switch-icon.svg';
import { addHours, format, parse } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { checkEmptyObject, setCurrency } from 'utils/functionality';
import axios from 'axios';
import { useAppContext } from 'components/Context/AppContext';
import { fetchSummaryAirportTransferOrder } from 'features/orders/actions';
import CheckboxField from 'components/Global/CheckboxField';
import UploadImageCustomOrder from 'components/Global/UploadImageCustomOrder';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';

const SingaporeForm = forwardRef(
  (
    {
      nextPage,
      selectedLuggage,
      selectedPassengers,
      setSelectedLuggage,
      setSelectedPassengers,
      startLocation,
      setStartLocation,
      rentalLocation,
      endLocation,
      setEndLocation,
      locationData,
      isOrderConfirmation,
      isSwitch,
      switchHandler,
      orderData,
      setOrderData,
      numberInputOnWheelPreventChange,
      startRentDate,
      setStartRentDate,
      setEndRentDate,
      selectedAdditionalItem,
      setSelectedAdditionalItem,
      isMeetAndGreetBoardRequire,
      setIsMeetAndGreetBoardRequire,
      ktpImageLink,
      uploadImageAction,
    },
    ref,
  ) => {
    const dispatch = useDispatch();
    const { showToast } = useAppContext();

    // GLOBAL STATE
    const { dataZone, dataAirport } = useSelector((state) => state.shuttleAirport);
    const { data: summaryData } = useSelector((state) => state.summaryOrder);

    const { data: additionalData } = useSelector((state) => state.addon);
    const { data: summaryOrderData } = useSelector((state) => state.summaryOrder);

    const { data: rentalServicesData } = useSelector((state) => state.services);

    // ADDITIONAL INPUT SEARCH VALUE
    const [additionalSearchInput, setAdditionalSearchInput] = useState('');

    const [boundingBoxLocation, setBoundingBoxLocation] = useState([]);

    const isAirportUploadKTPEnabled = useFliptBoolean('FLAG_FE_IDENTITY_REDIRECTION_AIRPORT', false, 'anonymous');

    const passangerAndLuggageHandler = (passengers, luggage) => {
      setSelectedPassengers(passengers);
      setSelectedLuggage(luggage);
      setOrderData({
        ...orderData,
        order_detail: {
          ...orderData.order_detail,
          adult_passenger: passengers.adults,
          child_passenger: passengers.child,
          // regular_suitcase: luggage.luggage,
          // large_suitcase: luggage.suitcaseXl,
          baggage: luggage.luggage,
        },
      });
    };

    const getBooundingBoxLocation = async (locationName) => {
      let boundingBox;
      try {
        const results = await axios.get(`https://nominatim.openstreetmap.org/search?q=${locationName}&format=json`);
        if (results.data?.length > 0) {
          boundingBox = results.data[0].boundingbox;
          setBoundingBoxLocation(boundingBox);
        }
      } catch (error) {
        showToast({ type: 'error', message: error });
      }
    };

    const gotFeeCurrency = (fee, currency) => {
      const RightFee =
        fee && currency === 'IDR'
          ? setCurrency(fee).replace('Rp', ``)
          : fee && currency === 'SGD'
          ? `${fee.toFixed(2)}`
          : fee === 0
          ? `0`
          : '-';
      return RightFee;
    };

    const getFilterParamsAddons = () => {
      let endBookingTime = orderData?.order_detail?.start_booking_time;
      let endBookingDate = orderData?.order_detail?.start_booking_date;

      if (endBookingTime) {
        const parsedDate = parse(`${endBookingDate} ${endBookingTime}`, 'yyyy-MM-dd HH:mm', new Date());

        const plusOneHours = addHours(parsedDate, 1);
        endBookingTime = format(plusOneHours, 'HH:mm');
      }

      return {
        locationId: rentalLocation?.id,
        locTimeId: rentalLocation?.time_zone_identifier,
        startDate: orderData.order_detail?.start_booking_date,
        endDate: endBookingDate,
        startTime: orderData.order_detail?.start_booking_time + ':00',
        endTime: endBookingTime + ':00',
      };
    };

    const submitHandler = async () => {
      // some validation
      const validUsername = orderData?.user_name.replace(/\s/g, '').length !== 0;
      const validUserWaNumber = orderData?.wa_number.replace(/s/g, '').length !== 0;
      const validStartBookingDate = orderData.order_detail.start_booking_date !== '';
      const validStartBookingTime = orderData.order_detail.start_booking_time !== '';
      const validPassengersAndLuggage =
        (orderData.order_detail.adult_passenger || orderData.order_detail.child_passenger) &&
        orderData.order_detail.baggage;
      const validFlightNumber = orderData.order_detail.flight_number.trim() !== '';
      const validOriginLocation = orderData.order_detail.origin && !checkEmptyObject(orderData.order_detail.origin);
      const validDestinationLocation =
        orderData.order_detail.destination && !checkEmptyObject(orderData.order_detail.destination);
      const validDetailOriginLocation = orderData.order_detail.rental_delivery_location_detail !== '';
      const validDetailDestinationLocation = orderData.order_detail.rental_return_location_detail !== '';
      const validMeetAndGreetBoard =
        orderData.customer_name_meet_and_greet && orderData.customer_name_meet_and_greet !== '';
      const validKtpImage = isAirportUploadKTPEnabled ? orderData?.order_detail?.identity?.ktp : true;

      if (!validUsername) {
        return showToast({ type: 'error', message: 'Masukan Customer Name' });
      } else if (!validUserWaNumber) {
        return showToast({ type: 'error', message: 'Masukan Customer Contact' });
      } else if (!validStartBookingDate) {
        return showToast({ type: 'error', message: 'Pilih Pickup Date' });
      } else if (!validStartBookingTime) {
        return showToast({ type: 'error', message: 'Pilih Pickup Time' });
      } else if (!validPassengersAndLuggage) {
        return showToast({ type: 'error', message: 'Piih Passengers Dan Luggage' });
      } else if (!validFlightNumber && isSwitch) {
        return showToast({ type: 'error', message: 'Masukan Flight Number' });
      } else if (!validOriginLocation) {
        return showToast({ type: 'error', message: 'Pilih Lokasi Pickup' });
      } else if (!validDestinationLocation) {
        return showToast({ type: 'error', message: 'Pilih Lokasi Drop Off' });
      } else if (!validDetailOriginLocation) {
        return showToast({ type: 'error', message: 'Masukan Detail Lokasi Pickup' });
      } else if (!validDetailDestinationLocation) {
        return showToast({ type: 'error', message: 'Masukan Detail Lokasi Drop Off' });
      } else if (isMeetAndGreetBoardRequire && !validMeetAndGreetBoard && isSwitch) {
        return showToast({ type: 'error', message: 'Masukan Meet And Greet Board' });
      } else if (!validKtpImage) {
        return showToast({ type: 'error', message: 'Upload KTP' });
      }

      let mappingAdditionalItem = [];

      const subServiceAirportTransfer = rentalServicesData
        ?.find((item) => item.name === 'Sewa Mobil')
        ?.sub_services?.find((item) => item.name === 'Airport Transfer');

      if (selectedAdditionalItem) {
        for (let addItionalChild of selectedAdditionalItem) {
          const additionalObj = {
            id: addItionalChild.additional.id,
            varieties: [
              {
                id: addItionalChild.additional.varieties[0].id,
                quantity: addItionalChild.total,
              },
            ],
          };

          mappingAdditionalItem.push(additionalObj);
        }
      }

      const payload = {
        start_booking_date: orderData.order_detail.start_booking_date,
        start_booking_time: orderData.order_detail.start_booking_time,
        order_type_id: orderData.order_type_id,
        rental_delivery_id: startLocation.id,
        rental_return_id: endLocation.id,
        adult_passenger: orderData.order_detail.adult_passenger,
        child_passenger: orderData.order_detail.child_passenger,
        location_id: rentalLocation.id,
        end_booking_date: orderData.order_detail.end_booking_date,
        end_booking_time: orderData.order_detail.end_booking_time,
        addons: mappingAdditionalItem.length === 0 ? undefined : mappingAdditionalItem,
        sub_services_id: subServiceAirportTransfer?.id,
        use_meet_greet_board: isMeetAndGreetBoardRequire,
      };

      try {
        const response = await dispatch(fetchSummaryAirportTransferOrder(payload));
        if (response.meta?.requestStatus === 'fulfilled') {
          nextPage();
          return;
        }
        showToast({ type: 'error', message: 'Terjadi Kesalahan' });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        showToast({ type: 'error', message: 'Terjadi Kesalahan' });
      }
    };

    useImperativeHandle(ref, () => ({
      actionInGrandGrandChild() {
        submitHandler();
      },
    }));

    useEffect(() => {
      if (checkEmptyObject(rentalLocation)) return;

      getBooundingBoxLocation(rentalLocation.name);
    }, [rentalLocation]);

    useEffect(() => {
      if (
        !orderData.order_detail.start_booking_date ||
        !orderData.order_detail.start_booking_time ||
        !orderData.order_type_id ||
        !startLocation?.name ||
        !endLocation?.name ||
        (!orderData.order_detail.adult_passenger && !orderData.order_detail.child_passenger) ||
        isOrderConfirmation
      )
        return;

      const subServiceAirportTransfer = rentalServicesData
        ?.find((item) => item.name === 'Sewa Mobil')
        ?.sub_services?.find((item) => item.name === 'Airport Transfer');

      let mappingAdditionalItem = [];

      if (selectedAdditionalItem) {
        for (let addItionalChild of selectedAdditionalItem) {
          const additionalObj = {
            id: addItionalChild.additional.id,
            varieties: [
              {
                id: addItionalChild.additional.varieties[0].id,
                quantity: addItionalChild.total,
              },
            ],
          };

          mappingAdditionalItem.push(additionalObj);
        }
      }

      const payload = {
        start_booking_date: orderData.order_detail.start_booking_date,
        start_booking_time: orderData.order_detail.start_booking_time,
        order_type_id: orderData.order_type_id,
        rental_delivery_id: startLocation.id,
        rental_return_id: endLocation.id,
        adult_passenger: orderData.order_detail.adult_passenger,
        child_passenger: orderData.order_detail.child_passenger,
        location_id: rentalLocation.id,
        end_booking_date: orderData.order_detail.end_booking_date,
        end_booking_time: orderData.order_detail.end_booking_time,
        addons: mappingAdditionalItem.length === 0 ? undefined : mappingAdditionalItem,
        sub_services_id: subServiceAirportTransfer?.id,
        use_meet_greet_board: isMeetAndGreetBoardRequire,
      };

      dispatch(fetchSummaryAirportTransferOrder(payload));
    }, [
      orderData.order_detail.start_booking_date,
      orderData.order_detail.start_booking_time,
      orderData.order_type_id,
      orderData.order_detail.adult_passenger,
      orderData.order_detail.child_passenger,
      startLocation,
      endLocation,
      rentalLocation,
      orderData.airport_transfer_package_id,
      selectedAdditionalItem,
      isMeetAndGreetBoardRequire,
    ]);

    return (
      <>
        <InputField
          label="Nama Customer"
          htmlFor="customer-name"
          placeholder="Tulis Nama Customer"
          value={orderData.user_name}
          onChange={(e) => setOrderData({ ...orderData, user_name: e.target.value })}
          disable={isOrderConfirmation}
        />
        <InputTelpField
          label="Contact Number"
          htmlFor="contact-number"
          value={orderData.wa_number}
          onChange={(e) => setOrderData({ ...orderData, wa_number: e.target.value, phone_country_code: '+65' })}
          disable={isOrderConfirmation}
          countryCodeValue={orderData?.phone_country_code}
          onWheel={numberInputOnWheelPreventChange}
          onSelectCountry={(code) => setOrderData({ ...orderData, phone_country_code: code })}
        />

        {isAirportUploadKTPEnabled && (
          <>
            <div>
              <h3 className="airport-transfer-form__form__ktp-label">KTP</h3>
              <UploadImageCustomOrder
                htmlFor="ktp"
                uploadAction={uploadImageAction}
                imageFile={ktpImageLink}
                base64={true}
                disable={isOrderConfirmation}
              />
            </div>

            <div />
          </>
        )}

        <div className="airport-transfer-form__form__pick-up-singapore">
          <SelectFieldDate
            label="Pickup Date"
            htmlFor="pickup-date"
            name="tanggal-mulai"
            handleDaySelect={(date) => {
              if (date) {
                setStartRentDate(date);
                setEndRentDate('');
                setOrderData({
                  ...orderData,
                  order_detail: {
                    ...orderData.order_detail,
                    start_booking_date: format(date, 'yyyy-MM-dd').toString(),
                  },
                });
                setSelectedAdditionalItem(undefined);
              }
            }}
            selectedDay={startRentDate}
            value={startRentDate !== '' ? format(startRentDate, 'dd-MM-yyyy') : startRentDate}
            placeholder="Pilih Tanggal"
            disable={isOrderConfirmation}
          />
          <SelectFieldTime
            label="Pick Up Time"
            htmlFor="pickup-time"
            placeholder="00:00"
            value={orderData.order_detail.start_booking_time}
            onChange={(hour, minute) => {
              let endBookingTime = `${hour}:${minute ? minute : '00'}`;
              let endBookingDate = orderData.order_detail.start_booking_date;

              const parsedDate = parse(`${endBookingDate} ${endBookingTime}`, 'yyyy-MM-dd HH:mm', new Date());
              const plusThreeHours = addHours(parsedDate, 1);
              endBookingTime = format(plusThreeHours, 'HH:mm');
              endBookingDate = format(plusThreeHours, 'yyyy-MM-dd');

              setOrderData({
                ...orderData,
                order_detail: {
                  ...orderData.order_detail,
                  start_booking_time: `${hour}:${minute ? minute : '00'}`,
                  end_booking_time: endBookingTime,
                  end_booking_date: endBookingDate,
                },
              });
              setSelectedAdditionalItem(undefined);
            }}
            disable={isOrderConfirmation ? true : startRentDate === '' ? true : false}
            showAllHours={true}
          />
        </div>

        <div className="airport-transfer-form__form__baggage-and-flight-number one-col">
          <SelectFieldPassengerAndLuggage
            label="Passengers and Suitcase"
            htmlFor="passengers-and-suitcase"
            selectedLuggage={selectedLuggage}
            selectedPassengers={selectedPassengers}
            onSelect={passangerAndLuggageHandler}
            disable={isOrderConfirmation}
          />
        </div>

        <div className="airport-transfer-form__form__location-map">
          <SelectFieldWithMap
            label="Pick Up"
            htmlFor="pickup-location"
            placeholder={isSwitch ? 'Pilih Airport' : 'Pilih Lokasi'}
            iconUrl={BlueMappin}
            value={startLocation.name}
            setValue={setStartLocation}
            centerCoord={locationData.latlng}
            positionCoord={startLocation.coord || [0, 0]}
            onClick={(item) => {
              setStartLocation({
                id: item.id,
                name: item.label,
                lat: item.y,
                lng: item.x,
                coord: [item.y, item.x],
                airport: item?.airport_location_type?.name === 'airport',
              });
              setOrderData({
                ...orderData,
                order_detail: {
                  ...orderData.order_detail,
                  rental_delivery_location: item.label,
                  origin: { lat: +item.y, long: +item.x },
                },
              });
            }}
            showMap={rentalLocation?.name}
            mapBounds={locationData.bounds}
            disable={isOrderConfirmation ? true : !rentalLocation.id}
            airportTransferSwitch
            dataAirportTransferSpecial={isSwitch ? dataAirport?.shuttle : dataZone?.shuttle}
            boundingBoxLocationAirportTransferSpecial={boundingBoxLocation}
          />
          <SelectFieldWithMap
            label="Drop Off"
            htmlFor="drop-off-location"
            placeholder={isSwitch ? 'Pilih Lokasi' : 'Pilih Airport'}
            iconUrl={YellowMappin}
            value={endLocation.name}
            setValue={setEndLocation}
            centerCoord={locationData?.latlng}
            positionCoord={endLocation.coord || [0, 0]}
            onClick={(item) => {
              setEndLocation({
                id: item.id,
                name: item.label,
                lat: item.y,
                lng: item.x,
                coord: [item.y, item.x],
                airport: item?.airport_location_type?.name === 'airport',
              });
              setOrderData({
                ...orderData,
                order_detail: {
                  ...orderData.order_detail,
                  rental_return_location: item.label,
                  destination: { lat: +item.y, long: +item.x },
                },
              });
            }}
            showMap={rentalLocation?.name}
            mapBounds={locationData.bounds}
            disable={isOrderConfirmation ? true : !rentalLocation}
            airportTransferSwitch
            dataAirportTransferSpecial={isSwitch ? dataZone?.shuttle : dataAirport?.shuttle}
            boundingBoxLocationAirportTransferSpecial={boundingBoxLocation}
          />

          {/* ICON SWITCH */}
          {!isOrderConfirmation && <SwitchIcon className="switch" onClick={switchHandler} />}
        </div>

        <InputField
          label="Detail Lokasi"
          htmlFor="pickup-detail"
          placeholder="Tulis detail lokasi"
          value={orderData?.order_detail?.rental_delivery_location_detail}
          onChange={(e) =>
            setOrderData({
              ...orderData,
              order_detail: { ...orderData.order_detail, rental_delivery_location_detail: e.target.value },
            })
          }
          icon={<DetailLocationIcon />}
          iconPosition="start"
          disable={isOrderConfirmation}
        />

        <InputField
          label="Detail Lokasi"
          htmlFor="dropoff-detail"
          placeholder="Tulis detail lokasi"
          value={orderData?.order_detail?.rental_return_location_detail}
          onChange={(e) =>
            setOrderData({
              ...orderData,
              order_detail: { ...orderData.order_detail, rental_return_location_detail: e.target.value },
            })
          }
          icon={<DetailLocationIcon />}
          iconPosition="start"
          disable={isOrderConfirmation}
        />

        {isSwitch && summaryData?.meet_greet_board?.is_active && (
          <div className="airport-transfer-form__form__meet-greet-board">
            <CheckboxField
              label="Meet&Greet Board (Optional)"
              name="meet-greet-board"
              value="meet-greet-board"
              className="meet-greet-board-checkbox"
              checked={isMeetAndGreetBoardRequire}
              onChange={(e) => {
                if (!e.target.checked) {
                  setOrderData({
                    ...orderData,
                    customer_name_meet_and_greet: '',
                  });
                }
                setIsMeetAndGreetBoardRequire(e.target.checked);
              }}
              disable={isOrderConfirmation}
            />
            <InputField
              label="Meet and Greet Board"
              htmlFor="meet-and-greet-board"
              placeholder="Welcome Big Ben!”, “Ben”, etc"
              value={orderData?.customer_name_meet_and_greet || ''}
              onChange={(e) =>
                setOrderData({
                  ...orderData,
                  customer_name_meet_and_greet: e.target.value,
                })
              }
              disable={isOrderConfirmation || !isMeetAndGreetBoardRequire}
            />
          </div>
        )}

        <InputField
          label="Flight Numbers"
          htmlFor="flight-numbers"
          placeholder="Tulis Flight Numbers"
          value={orderData.order_detail.flight_number}
          onChange={(e) =>
            setOrderData({
              ...orderData,
              order_detail: { ...orderData.order_detail, flight_number: e.target.value },
            })
          }
          disable={isOrderConfirmation || !isSwitch}
          icon={<FlightIcon />}
          iconPosition="start"
        />

        <div className="airport-transfer-form__form__additional-item">
          <h2>Additional</h2>
          <div className="wrapper">
            <SelectFieldAdditionalItem
              label="Pilih Tambahan"
              id="tambahan"
              className="additional"
              placeholder="Cari Perlengkapan Khusus.."
              selectedAdditionalItem={selectedAdditionalItem}
              setSelectedAdditionalItem={setSelectedAdditionalItem}
              value={additionalSearchInput}
              onChange={(e) => setAdditionalSearchInput(e.target.value)}
              data={additionalData?.data || []}
              disable={isOrderConfirmation || !additionalData || checkEmptyObject(additionalData)}
              filterParams={getFilterParamsAddons()}
            />

            <InputField
              label="Total Biaya Permintaan Khusus"
              className="input-total-biaya-permintaan"
              placeholder="IDR 0"
              value={
                summaryOrderData?.addon_total_price && selectedAdditionalItem
                  ? setCurrency(summaryOrderData.addon_total_price)
                  : ''
              }
              disable
            />
          </div>
        </div>

        <div
          className="airport-transfer-form__form__total-price"
          style={{
            gridRow: '7 / 8',
          }}
        >
          <h3>Total Price : </h3>
          <p>IDR : {gotFeeCurrency(summaryData?.total_payment, 'IDR') || 0}</p>
        </div>
      </>
    );
  },
);

SingaporeForm.displayName = 'SingaporeForm';
export default SingaporeForm;
